// extracted by mini-css-extract-plugin
export var iconContainer = "ActionIcon-module--iconContainer--ZdwYE";
export var iconWrapper = "ActionIcon-module--iconWrapper--gMv2u";